import { apiClient } from "./client";
import type {
  Company,
  Tag,
  TagCreate,
  TagUpdate,
  TagWithCount,
} from "./types";

// ─── Project tags ──────────────────────────────────────────────────────────

export async function listTags(slug: string): Promise<TagWithCount[]> {
  const res = await apiClient.get<TagWithCount[]>(`/projects/${slug}/tags`);
  return res.data;
}

export async function createTag(
  slug: string,
  payload: TagCreate,
): Promise<Tag> {
  const res = await apiClient.post<Tag>(`/projects/${slug}/tags`, payload);
  return res.data;
}

export async function updateTag(
  slug: string,
  id: number,
  payload: TagUpdate,
): Promise<Tag> {
  const res = await apiClient.patch<Tag>(
    `/projects/${slug}/tags/${id}`,
    payload,
  );
  return res.data;
}

export async function deleteTag(slug: string, id: number): Promise<void> {
  await apiClient.delete(`/projects/${slug}/tags/${id}`);
}

// ─── Company tag membership ────────────────────────────────────────────────

export async function addTagsToCompany(
  slug: string,
  companyId: number,
  tagIds: number[],
): Promise<Company> {
  const res = await apiClient.post<Company>(
    `/projects/${slug}/companies/${companyId}/tags`,
    { tag_ids: tagIds },
  );
  return res.data;
}

export async function removeTagFromCompany(
  slug: string,
  companyId: number,
  tagId: number,
): Promise<Company> {
  const res = await apiClient.delete<Company>(
    `/projects/${slug}/companies/${companyId}/tags/${tagId}`,
  );
  return res.data;
}
